import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
    name: 'project_status',
})
export class StatusPipe implements PipeTransform {
    transform(type: number) {
        if (type == 0) {
            return 'Inactive'
        } else if (type == 1) {
            return 'Completed'
        } else if (type == 2) {
            return 'Active'
        } 
    //     else if (type == 2) {
    //         return 'Coming Up'
    //     }
    //     else if (type == 3) {
    //       return 'Overdue'
    //   }
    //   else if (type == 4) {
    //     return 'Re-opened'
    //}
        return type
    }
}
